import "./Contacts.css";
import { useState } from "react";
import api from "../../lib/api";
function Contacts() {
	const [formData, setFormData] = useState({
		name: "",
		email: "",
		message: "",
	});
	const [isLoading, setIsLoading] = useState(false);

	const handleChange = (e) => {
		const { name, value } = e.target;
		setFormData((prevState) => ({
			...prevState,
			[name]: value,
		}));
	};

	const handleSubmit = async (e) => {
		e.preventDefault();
		setIsLoading(true);
		try {
			const response = await api.post("/message", formData);
			if (response.data.statusCode === 201) {
				alert("Mensagem enviada com sucesso!");
				setFormData({
					name: "",
					email: "",
					message: "",
				});
			} else {
				throw new Error("Erro ao enviar mensagem");
			}
		} catch (error) {
			alert(
				"Não foi possível enviar sua mensagem. Por favor, tente novamente."
			);
		} finally {
			setIsLoading(false);
		}
	};

	return (
		<section id="contacts">
			<div className="h-100 mt-sm-5 px-sm-5 py-sm-5 pt-5">
				<div className="w-100 py-sm-3 color-300 text-end">
					<h2 className="fs-2 fw-bold">Contatos</h2>
					<p className="color-600 fs-5">Entre em contato comigo.</p>
				</div>
			</div>
			<div className="row align-items-center p-sm-5 bg-700-fade-reverse d-flex">
				<div
					className="col-12 order-2 col-md-7 box p-5 bg-blur my-5 my-sm-0"
					id="stripe"
				>
					<h3 className="color-100 fw-bold fs-1 mb-2">Mande uma mensagem</h3>
					<form onSubmit={handleSubmit}>
						<div className="mb-3">
							<label htmlFor="name" className="form-label color-300">
								Nome
							</label>
							<input
								type="text"
								className="w-100 bg-transparent color-300 no-border text-white"
								id="name"
								name="name"
								value={formData.name}
								onChange={handleChange}
								aria-describedby="nameHelp"
								required
								minLength={3}
								maxLength={30}
							/>
							<div id="nameHelp" className="form-text color-600">
								Não compartilharemos seu nome com ninguém.
							</div>
						</div>
						<div className="mb-3">
							<label htmlFor="email" className="form-label color-300">
								Email
							</label>
							<input
								type="email"
								className="w-100 bg-transparent color-300 no-border text-white"
								id="email"
								name="email"
								value={formData.email}
								onChange={handleChange}
								aria-describedby="emailHelp"
								required
								minLength={3}
								maxLength={50}
							/>
							<div id="emailHelp" className="form-text color-600">
								Não compartilharemos seu email com ninguém.
							</div>
						</div>
						<div className="mb-3">
							<label htmlFor="message" className="form-label color-300">
								Mensagem
							</label>
							<textarea
								className="w-100 bg-transparent color-300 no-border text-white"
								id="message"
								name="message"
								rows="3"
								value={formData.message}
								onChange={handleChange}
								required
								minLength={3}
								maxLength={1000}
							></textarea>
						</div>
						<button
							type="submit"
							className="btn btn-dark bg-700 text-white"
							disabled={isLoading}
						>
							{isLoading ? (
								<div className="spinner-border spinner-border-sm" role="status">
									<span className="visually-hidden">Carregando...</span>
								</div>
							) : (
								<>
									Enviar
									<svg
										className="fill-white"
										width="14"
										height="14"
										viewBox="0 0 14 14"
										fill="none"
										xmlns="http://www.w3.org/2000/svg"
									>
										<path
											d="M10.4767 6.16664L6.00668 1.69664L7.18501 0.518311L13.6667 6.99998L7.18501 13.4816L6.00668 12.3033L10.4767 7.83331H0.333344V6.16664H10.4767Z"
											fill="white"
										></path>
									</svg>
								</>
							)}
						</button>
					</form>
				</div>
				<div className="col-12 order-1 col-md-5 p-sm-5">
					<h3 className="color-100 fw-bold fs-1 mb-2 d-none d-sm-block">
						Contatos
					</h3>
					<h5 className="color-100 fw-bold mt-5 mb-3">Email</h5>
					<a
						href="mailto:clayton@srocha.dev"
						_target="blank"
						className="text-decoration-none d-inline-flex gap-2 align-items-center"
					>
						<img src="/assets/envelope.svg" alt="Icone de envelope" />
						clayton@srocha.dev
					</a>
					<h5 className="mt-5 color-100">
						Redes Sociais{" "}
						<svg
							width="16"
							height="16"
							data-icon="chevron-down"
							className="fill-100"
						>
							<symbol id="ai:local:chevron-down" viewBox="0 0 25 26">
								<path
									fill="none"
									stroke="currentColor"
									strokeLinecap="round"
									strokeLinejoin="round"
									strokeWidth="2"
									d="M2 8.5 12.5 19 23 8.5"
								></path>
							</symbol>
							<use href="#ai:local:chevron-down"></use>
						</svg>
					</h5>
					<div className="d-flex flex-column gap-2 mt-3">
						<div className="icon">
							<a
								href="https://www.github.com/srclayton"
								target="_blank"
								className="text-decoration-none d-inline-flex gap-2 align-items-center"
								rel="noreferrer"
							>
								<img
									src="/assets/github.svg"
									alt="github icon."
									className="img-fluid"
								/>
								<span>/srclayton</span>
							</a>
						</div>
						<div className="icon">
							<a
								href="https://www.linkedin.com/in/srclayton"
								target="_blank"
								className="text-decoration-none d-inline-flex gap-2 align-items-center"
								rel="noreferrer"
							>
								<img
									src="/assets/linkedin-in.svg"
									alt="linkedin-in icon."
									className="img-fluid"
								/>
								<span>/srclayton</span>
							</a>
						</div>
					</div>
				</div>
			</div>
		</section>
	);
}

export default Contacts;
